export var blue = "#497b99";
export var debounceTimeInMs = 250;
//# sourceMappingURL=constants.js.map